import moment from "moment";
import { PreparedSession, TrackerForm } from "./types";

// 1. Time-Related Functions

export const getPassedSeconds = (startTime: string) => {
  const time = moment.utc(startTime).local();
  return moment().diff(time, "second");
};

export const getDates = (
  initialStart: string,
  initialEnd: string,
  day: moment.MomentInput,
) => {
  const startMoment = moment(initialStart, "HH:mm").set({
    year: moment(day).year(),
    month: moment(day).month(),
    date: moment(day).date(),
  });
  const endMoment = moment(initialEnd, "HH:mm").set({
    year: moment(day).year(),
    month: moment(day).month(),
    date: moment(day).date(),
  });
  if (endMoment.isBefore(startMoment)) {
    endMoment.add(1, "day");
  }
  return {
    start: startMoment.utc().format(),
    end: endMoment.utc().format(),
  };
};

// 2. Data Parsers and Converters

export const convertToUTC = (date?: string): string => {
  return moment.utc(date).toISOString();
};

export const convertToLocal = (date: string): moment.Moment => {
  if (date == null) return moment();
  return moment.utc(date).local();
};

// 3. Validators

type ValidationResult = {
  isValid: boolean;
  errorMessage?: string;
};

export const validateTrackerForm = (
  formData: TrackerForm,
  typeOfTracking: string,
  endTime?: string,
): ValidationResult => {
  if (!formData.projectId) {
    return {
      isValid: false,
      errorMessage: "Validation error: projectId is required.",
    };
  }
  if (typeOfTracking === "Manual" && !endTime) {
    return {
      isValid: false,
      errorMessage: "Validation error: End time is required.",
    };
  }
  return { isValid: true };
};

// 4. Form Handling

export const prepareSessionForTracking = (
  formData: TrackerForm,
): PreparedSession => {
  const preparedSession: PreparedSession = {
    start: convertToUTC(undefined),
    projectId: formData.projectId,
    description: formData.description,
  };
  return preparedSession;
};
